
export const colors = {
    blue6: "#106bd5"
}
